import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import "jquery-slimscroll/jquery.slimscroll.min";
import { Link } from "react-router-dom";

class SidebarContent extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentDidMount() {
    const nav = this.nav;
    const $nav = $(nav);

    // scroll
    $nav.slimscroll({
      height: "100%"
    });

    // Append icon to submenu
    $nav
      .find(".prepend-icon")
      .prepend('<i class="material-icons">keyboard_arrow_right</i>');

    // AccordionNav
    const slideTime = 250;
    const $lists = $nav.find("ul").parent("li");
    $lists.append('<i class="material-icons icon-has-ul">arrow_drop_down</i>');
    const $As = $lists.children("a");

    // Disable A link that has ul
    $As.on("click", event => event.preventDefault());

    // Accordion nav
    $nav.on("click", e => {
      const target = e.target;
      const $parentLi = $(target).closest("li"); // closest, insead of parent, so it still works when click on i icons
      if (!$parentLi.length) return; // return if doesn't click on li
      const $subUl = $parentLi.children("ul");

      // let depth = $subUl.parents().length; // but some li has no sub ul, so...
      const depth = $parentLi.parents().length + 1;

      // filter out all elements (except target) at current depth or greater
      const allAtDepth = $nav.find("ul").filter(function() {
        if ($(this).parents().length >= depth && this !== $subUl.get(0)) {
          return true;
        }
        return false;
      });
      allAtDepth
        .slideUp(slideTime)
        .closest("li")
        .removeClass("open");

      // Toggle target

      if ($parentLi.has("ul").length) {
        $parentLi.toggleClass("open");
      }
      $subUl.stop().slideToggle(slideTime);
    });

    // HighlightActiveItems
    const $links = $nav.find("a");
    /* const currentLocation = history.location; */

    function highlightActive(pathname) {
      const path = `#${pathname}`;

      $links.each((i, link) => {
        const $link = $(link);
        const $li = $link.parent("li");
        const href = $link.attr("href");

        if ($li.hasClass("active")) {
          $li.removeClass("active");
        }
        if (path.indexOf(href) === 0) {
          $li.addClass("active");

          // check hierarchy - chechenblaikner
          let liUlLiLength = $li.parent("ul").has("li");
          if (liUlLiLength) {
            $li
              .parent("ul")
              .has("li")
              .addClass("open");
            $li
              .parent("ul")
              .has("li")
              .css("display", "block");
            $li.addClass("active");
          }
        }
      });
    }
    /* highlightActive(currentLocation.pathname); */
     //TODO: add histiory / locaiton change event listener
    //https://stackoverflow.com/questions/68782781/react-router-v6-history-listen
    /*history.listen(location => {
      highlightActive(location.pathname);
    }); */
  }

  render() {
    //  const hasRights = this.state.hasApproverRights;
    //   const isHrMember = this.state.isHrMember;

    return (
      <ul
        className="nav"
        ref={c => {
          this.nav = c;
        }}
      >
        <li className="nav-header border-bottom pb-2">
          <span>Vendor Master Data Approval</span>
        </li>

        <li>
          <Link to={{ pathname: "/app/overview" }}>
            <i className="nav-icon material-icons">list</i> <span>Overview</span>
          </Link>
        </li>

        <li>
          <Link to={{ pathname: "/app/createVendor" }}>
            <i className="nav-icon material-icons">add</i>{" "}
            <span>Create Vendor</span>
          </Link>
        </li>

        <li>
          <Link to={{ pathname: "/app/changeVendor" }}>
            <i className="nav-icon material-icons">create</i>{" "}
            <span>Change Vendor</span>
          </Link>
        </li>


        <li>
          <Link to={{ pathname: "/app/extendVendor" }}>
            <i className="nav-icon material-icons">extension</i>{" "}
            <span>Extend Vendor</span>
          </Link>
        </li>

        <li>
          <Link to={{ pathname: "/app/reactivateVendor" }}>
            <i className="nav-icon material-icons">play_arrow</i>{" "}
            <span>Reactivate Vendor</span>
          </Link>
        </li>

        {/* <li>
          <Link to={{ pathname: "/app/vendor/null/true" }}>
            <i className="nav-icon material-icons">create</i>{" "}
            <span>Change Vendor</span>
          </Link>
        </li>

        <li>
          <Link to={{ pathname: "/app/vendor/null/false/true" }}>
            <i className="nav-icon material-icons">extension</i>{" "}
            <span>Extend Vendor</span>
          </Link>
        </li>

        <li>
          <Link to={{ pathname: "/app/reactivate" }}>
            <i className="nav-icon material-icons">play_arrow</i>{" "}
            <span>Reactivate Vendor</span>
          </Link>
        </li> */}
        
      </ul>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  layoutBoxed: state.settings.layoutBoxed,
  navCollapsed: state.settings.navCollapsed,
  navBehind: state.settings.navBehind,
  fixedHeader: state.settings.fixedHeader,
  sidebarWidth: state.settings.sidebarWidth,
  theme: state.settings.theme
});

export default connect(mapStateToProps)(SidebarContent);
